import gaiupApolloClient from "@/graphql/services/ApolloClient";
import {
  GetProjectSpeckleStreamIdDocument,
  type GetProjectSpeckleStreamIdQuery,
  type GetProjectSpeckleStreamIdQueryVariables,
} from "@/graphql";

/**
 * The stream id the project row holds right now, read from Hasura past the cache.
 *
 * The attach itself is the API's: `PUT api/BuildingProject/{id}/updateSpeckleMetaData/{streamId}`
 * (RTLCA-5546) records the stream on the Marten aggregate and then writes `speckle_stream`,
 * `project.speckle_stream_id` and the model rows into Hasura over the admin secret. No client permission
 * covers any of that — RTLCA-5554 keeps the column off the project row's client write on purpose — so
 * the client's part is to refuse to take the endpoint's word for it. The bug this guards against
 * (RTLCA-5540) was an attach that answered 200 and changed nothing.
 */
export const readProjectSpeckleStreamId = async (projectId: string): Promise<string | null> => {
  const { data } = await gaiupApolloClient.query<GetProjectSpeckleStreamIdQuery, GetProjectSpeckleStreamIdQueryVariables>({
    query: GetProjectSpeckleStreamIdDocument,
    variables: { projectId },
    fetchPolicy: "network-only",
  });

  return data?.project?.speckleStreamId ?? null;
};
